import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { PracticumValue } from "../../../services/api/instances/practicumApi/types";
import type { PracticumState } from "./types";

export const initialState: PracticumState = {
  practicumValue: null,
  isPracticumLoading: false,
};

const practicumSlice = createSlice({
  name: "practicum",
  initialState,
  reducers: {
    setPracticumValue: (state, action: PayloadAction<PracticumValue>) => {
      state.practicumValue = action.payload;
    },

    setPracticumLoadingObjectAction: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isPracticumLoading = action.payload;
    },
  },
});

export const practicumReducers = practicumSlice.reducer;
export const { setPracticumValue, setPracticumLoadingObjectAction } =
  practicumSlice.actions;
